import React from 'react';

function CardValidacion({ imagenurl, title }) {
  return (
    <div className='relative w-full sm:w-64 md:w-72 lg:w-80 h-96 rounded-xl overflow-hidden shadow-lg bg-white group transition-transform duration-300 hover:scale-105 hover:shadow-2xl py-8'>
      {/* Imagen con hover y efecto de escala */}
      <div className='relative w-full h-60 overflow-hidden'>
        <img 
          src={imagenurl}
          alt={title}
          className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-110'
        />
      </div>

      {/* Contenedor del texto */}
      <div className="p-12 sm:p-6 text-center">
        <h2 className='text-lg py-12sm:text-xl font-semibold uppercase text-gray-800 hover:text-blue-600 transition-colors duration-300 mb-2'>
          {title}
        </h2>
      
      </div>

     
    </div>
  );
}

export default CardValidacion;